 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"AccountOpening":"AccountOpening","BackTopBottom":"BackTopBottom","Caption":"Caption","Copyright":"Copyright","DataBox":"DataBox","HomeFooter":"HomeFooter","LivePlayer":"LivePlayer","MoreTabs":"MoreTabs","Nav":"Nav","NormalCaption":"NormalCaption","Offline":"Offline","Stick":"Stick","Tip":"Tip","ViewMoreLink":"ViewMoreLink","WxLaunchApp":"WxLaunchApp","vendors~Atlas~FiveNavPic~FourNavPic~InformationFlow~MdBanner~ThreeNavPic":"vendors~Atlas~FiveNavPic~FourNavPic~InformationFlow~MdBanner~ThreeNavPic","Atlas":"Atlas","FiveNavPic":"FiveNavPic","FourNavPic":"FourNavPic","ThreeNavPic":"ThreeNavPic","vendors~BigImage~Hongbao~NewsStream~NoImage~OneImage~ThreeImage~TwoImage":"vendors~BigImage~Hongbao~NewsStream~NoImage~OneImage~ThreeImage~TwoImage","Hongbao":"Hongbao","NoImage":"NoImage","vendors~BigImage~NewsStream~OneImage~ThreeImage~TwoImage":"vendors~BigImage~NewsStream~OneImage~ThreeImage~TwoImage","BigImage":"BigImage","OneImage":"OneImage","ThreeImage":"ThreeImage","TwoImage":"TwoImage","vendors~NewsStream":"vendors~NewsStream","vendors~BigImg~BigTopic~BottomSlides~BrowserGuideLayer~CallupHead~IndexSlides~InformationFlow~MarkTa~bbbc43f7":"vendors~BigImg~BigTopic~BottomSlides~BrowserGuideLayer~CallupHead~IndexSlides~InformationFlow~MarkTa~bbbc43f7","BrowserGuideLayer":"BrowserGuideLayer","MarkTabs":"MarkTabs","PageBottomBrand":"PageBottomBrand","vendors~MdBanner":"vendors~MdBanner","vendors~BigImg~BigTopic~InformationFlow~SingleTitle~SlideImg~TitleImg~TwoImg":"vendors~BigImg~BigTopic~InformationFlow~SingleTitle~SlideImg~TitleImg~TwoImg","SingleTitle":"SingleTitle","SlideImg":"SlideImg","TwoImg":"TwoImg","vendors~BigTopic~InformationFlow~TitleImg":"vendors~BigTopic~InformationFlow~TitleImg","InformationFlow":"InformationFlow","vendors~BigImg":"vendors~BigImg","BigImg":"BigImg","TitleImg":"TitleImg","vendors~BigTopic":"vendors~BigTopic","BigTopic":"BigTopic","vendors~BottomSlides~IndexSlides~NormalSlides~ShareSlides~Slides~UpgradeBottomSlides":"vendors~BottomSlides~IndexSlides~NormalSlides~ShareSlides~Slides~UpgradeBottomSlides","vendors~BottomSlides~UpgradeBottomSlides":"vendors~BottomSlides~UpgradeBottomSlides","UpgradeBottomSlides":"UpgradeBottomSlides","vendors~IndexSlides":"vendors~IndexSlides","vendors~CallupHead":"vendors~CallupHead","vendors~Comment~ShareComment":"vendors~Comment~ShareComment","vendors~ShareComment":"vendors~ShareComment","vendors~Player":"vendors~Player","vendors~Survey":"vendors~Survey","vendors~WXGuideLayer":"vendors~WXGuideLayer","vendors~WxLaunchHack":"vendors~WxLaunchHack","Slides":"Slides","vendors~NormalSlides":"vendors~NormalSlides","vendors~ShareSlides":"vendors~ShareSlides","vendors~CallupVideoAppHead":"vendors~CallupVideoAppHead","vendors~Comment~LoginDialog":"vendors~Comment~LoginDialog","LoginDialog":"LoginDialog","vendors~Comment":"vendors~Comment","Comment":"Comment","vendors~Img":"vendors~Img","vendors~NormalTabs":"vendors~NormalTabs","vendors~QQShare":"vendors~QQShare","vendors~SimpleGuideLayer":"vendors~SimpleGuideLayer","vendors~SlidesTabs":"vendors~SlidesTabs","vendors~pics":"vendors~pics","pics":"pics"}[chunkId]||chunkId) + "._mobile." + {"0":"88312b9d","1":"da32272a","2":"8d5fe466","3":"bda56cb6","4":"75eb6a97","5":"0ee5805f","6":"416cc769","AccountOpening":"fce083e0","BackTopBottom":"d3b56c36","Caption":"f0898bf0","Copyright":"c973b055","DataBox":"0cc828b3","HomeFooter":"71b81fe0","LivePlayer":"300c0f4d","MoreTabs":"1b79fc34","Nav":"02e75ca1","NormalCaption":"d6e7d620","Offline":"ec73a1b1","Stick":"75c17637","Tip":"14c3218d","ViewMoreLink":"5a66fd4e","WxLaunchApp":"8d98287f","vendors~Atlas~FiveNavPic~FourNavPic~InformationFlow~MdBanner~ThreeNavPic":"e0a9d81f","Atlas":"a7b284a7","FiveNavPic":"a248bea6","FourNavPic":"f46ff877","ThreeNavPic":"275972e7","vendors~BigImage~Hongbao~NewsStream~NoImage~OneImage~ThreeImage~TwoImage":"1d917f1c","Hongbao":"09900dbc","NoImage":"5d127acf","vendors~BigImage~NewsStream~OneImage~ThreeImage~TwoImage":"73eca85e","BigImage":"5e7ecf75","OneImage":"057e2d5c","ThreeImage":"fe859dd5","TwoImage":"fa7db953","vendors~NewsStream":"19daceeb","vendors~BigImg~BigTopic~BottomSlides~BrowserGuideLayer~CallupHead~IndexSlides~InformationFlow~MarkTa~bbbc43f7":"45368e2b","BrowserGuideLayer":"6eb892e2","MarkTabs":"c37f6ce0","PageBottomBrand":"1e50da1e","vendors~MdBanner":"c7b81f8d","vendors~BigImg~BigTopic~InformationFlow~SingleTitle~SlideImg~TitleImg~TwoImg":"19f4bef7","SingleTitle":"5c2ff2fb","SlideImg":"78f8e211","TwoImg":"31cc030d","vendors~BigTopic~InformationFlow~TitleImg":"b33c2499","InformationFlow":"3b3505af","vendors~BigImg":"fcf5e993","BigImg":"30814c42","TitleImg":"484b2bb6","vendors~BigTopic":"bd483868","BigTopic":"8f00dd8f","vendors~BottomSlides~IndexSlides~NormalSlides~ShareSlides~Slides~UpgradeBottomSlides":"654b9aec","vendors~BottomSlides~UpgradeBottomSlides":"6dee0950","UpgradeBottomSlides":"72f3b23b","vendors~IndexSlides":"c75b1745","vendors~CallupHead":"0b05e6fb","vendors~Comment~ShareComment":"1f2b3bf0","vendors~ShareComment":"a75a27dc","vendors~Player":"92e04e0e","vendors~Survey":"7f363202","vendors~WXGuideLayer":"26c5ee1d","vendors~WxLaunchHack":"99d6ef82","Slides":"36d7fa47","vendors~NormalSlides":"34579a05","vendors~ShareSlides":"f86595f1","vendors~CallupVideoAppHead":"821212a1","vendors~Comment~LoginDialog":"bcad4b00","LoginDialog":"049b7bcf","vendors~Comment":"6efe1ac9","Comment":"c6cb71f6","vendors~Img":"6ddfa233","vendors~NormalTabs":"f839cfff","vendors~QQShare":"f58f68c8","vendors~SimpleGuideLayer":"96c07db9","vendors~SlidesTabs":"df2a362d","vendors~pics":"dfcc6823","pics":"8a162db9"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				if (script.src.indexOf(window.location.origin + '/') !== 0) {
 					script.crossOrigin = "anonymous";
 				}
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://x2.ifengimg.com/fe/shank/custom/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
